export const USER_GET_TFA_DETAILS_DATA = 'USER_GET_TFA_DETAILS_DATA';
export const USER_CONTACT_VERIFIED = 'USER_CONTACT_VERIFIED';
export const WEBAUTHN_REG_DATA = 'WEBAUTHN_REG_DATA';
export const AUTHENTICATOR_DEVICES_DATA = 'AUTHENTICATOR_DEVICES_DATA';
export const TFA_UPDATE_STATUS = 'TFA_UPDATE_STATUS';
export const TFA_SET_ERROR = 'TFA_SET_ERROR';
export const TFA_CLEAR_ERROR = 'TFA_CLEAR_ERROR';
